<template>
<div style="height: 100%; width: 100%;">
    <owal-panel style="margin: 2.5rem 5rem 0rem 5rem;" title="Snooze Alert">
      <p v-if="wrongDomain">
        The alert you're trying to snooze does not belong to {{currentDomain.description}}
      </p>
      <p v-else>
        You're about to snooze the "{{alert.description}}" alert at camera {{camera.description}} for
        <input class="duration-input" type="number" v-model="hours"/> hours
        <input class="duration-input" type="number" v-model="minutes"/> minutes
      </p>
      <owal-button @click="submitSnoozeRequest">Snooze</owal-button>
      <p v-if="result">
        Alert was successfully snoozed!
      </p>
    </owal-panel>
</div>
</template>

<script>
import { OwalPanel, OwalButton } from '@/libraries/owal-ui/'
import { getAlertConfigForDomain, snoozeAlert } from '@/libraries/api/dna'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'SnoozeAlert.vue',
  components: {
    OwalButton,
    OwalPanel,
  },
  props: {
    alertConfigId: String,
    cameraUUID: String,
    notificationTargetId: String,
    duration: Number,
    oneTimeToken: String,
    snoozedAt: Number, // epoch
  },
  data () {
    return {
      alert: {},
      camera: {},
      minutes: 0,
      hours: 0,
      result: undefined,
      wrongDomain: false,
    }
  },
  async created() {
    await this.setup()
  },
   watch: {
    async currentDomainUUID () {
      await this.setup()
    },
  },
  methods: {
    async setup() {
      const { data } = await getAlertConfigForDomain(this.currentDomainUUID)
      const alert = data.data.find(alertConfig => alertConfig.alert_config_id === this.alertConfigId)
      let camera
      if (alert) {
        this.alert = alert
        camera = this.alert.cameras.find(camera => camera.uuid === this.cameraUUID)
        this.camera = camera
        this.wrongDomain = false
      }
      if (!alert || !camera) {
        this.wrongDomain = true
      }
      this.durationToComponents(this.duration)
    },
    durationToComponents(durationInSeconds) {
      console.log(durationInSeconds)
      this.hours = Math.floor(durationInSeconds / 3600)
      console.log(this.hours)
      this.minutes = Math.floor((durationInSeconds - (this.hours * 3600)) / 60)
      console.log(this.minutes)
    },
    humanize(durationInSeconds) {
      console.log(durationInSeconds)
      return moment.duration({ seconds: durationInSeconds }).humanize()
    },
    async submitSnoozeRequest() {
      const result = await snoozeAlert({
        alert_config_id: this.alertConfigId,
        camera_uuid: this.cameraUUID,
        duration: (this.hours * 3600) + (this.minutes * 60),
        snoozed_at: this.snoozedAt,
      })
      if (result.status === 200) {
        this.result = 'successful'
      }
    },
  },
  computed: {
    ...mapGetters({
        currentDomainUUID: 'currentDomainUUID',
        currentDomain: 'currentDomain',
    }),
  },
}
</script>

<style scoped>
.duration-input {
  display: inline;
  width: 4rem;
}

</style>
